import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { policyholderProxies } from '~/models/generalConstants'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function isPolicyHolderOrProxy(value: string | undefined) {
    return (
        value === 'policyholder' ||
        (value && policyholderProxies.includes(value))
    )
}

export function setItemWithExpiry(
    key: string,
    value: string,
    ttl: number,
    callback?: () => void
) {
    if (callback) callback()

    const now = new Date()
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
}

export function getItemWithExpiry(key: string, callback?: () => void) {
    try {
        const itemStr = localStorage.getItem(key)
        if (!itemStr) {
            if (callback) callback()
            return null
        }
        const item = JSON.parse(itemStr)
        const now = new Date()

        if (!item?.expiry || now.getTime() > item.expiry) {
            if (callback) callback()

            localStorage.removeItem(key)
            return null
        }

        return item.value
    } catch {
        if (callback) callback()
        return null
    }
}
